export { default } from './ArtistAddRecordingToProject';
